
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum TaskActionType {
	meeting = 0,
	contact = 1,
	correction = 2,
	inquiry = 3,
	qualificationCall = 4,
	onboardingTrigger = 5,
	design = 6,
	approval = 7,
	designApprovalTrigger = 8,
	presentation = 9,
	presentationTrigger = 10,
	invoice = 11,
	productLaunch = 12,
	dnsTrigger = 13,
	orderDkHostmasterDomainTrigger = 14,
	awaitDkHostmasterResponseTrigger = 15,
	openCallInDSv2Trigger = 16,
	closeCallInDSv2Trigger = 17
}
export namespace TaskActionType {
	export function getKeys(): Map<TaskActionType, string> {
		return new Map([[0, 'meeting'], [1, 'contact'], [2, 'correction'], [3, 'inquiry'], [4, 'qualificationCall'], [5, 'onboardingTrigger'], [6, 'design'], [7, 'approval'], [8, 'designApprovalTrigger'], [9, 'presentation'], [10, 'presentationTrigger'], [11, 'invoice'], [12, 'productLaunch'], [13, 'dnsTrigger'], [14, 'orderDkHostmasterDomainTrigger'], [15, 'awaitDkHostmasterResponseTrigger'], [16, 'openCallInDSv2Trigger'], [17, 'closeCallInDSv2Trigger']]);
	}
}
